<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 无人门岗大屏 -->
    <DoorpostBanner></DoorpostBanner>
    <!-- 无人门岗硬件描述 -->
    <DoorpostDescribe></DoorpostDescribe>
    <!-- 业务应用场景 -->
    <DoorpostScene></DoorpostScene>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import DoorpostBanner from '../../../../components/pc/Programme/DoorpostComponents/DoorpostBanner.vue'
import DoorpostDescribe from '../../../../components/pc/Programme/DoorpostComponents/DoorpostDescribe.vue'
import DoorpostScene from '../../../../components/pc/Programme/DoorpostComponents/DoorpostScene.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    DoorpostBanner,
    DoorpostDescribe,
    DoorpostScene,
  },
};
</script>

<style scoped>
</style>
